export default "__VITE_ASSET__DM5wg_pH__"